 document.addEventListener("DOMContentLoaded", () => {
    const dataScript = document.getElementById("sas-selling-options-type-data");
    if (!dataScript) return;

    let data = null;

    try {
        data = JSON.parse(dataScript.textContent);
    } catch (e) {
        console.error("Error JSON:", e);
        return;
    }

    function normalize(type) {
        if (!type) return null;

        type = type.toLowerCase().trim();

        if (type.includes("call")) return "call_for_price";
        if (type.includes("custom")) return "custom_button";
        if (type.includes("inquire")) return "inquire";

        return null;
    }

    const globalType = normalize(data.globalType);

    const buttons = {
        call_for_price: document.querySelector(".call_btn"),
        custom_button: document.querySelector(".custom_btn"),
        inquire: document.querySelector(".btn-inquired")
    };

    function hideAll() {
        Object.values(buttons).forEach(btn => {
            if (btn) btn.style.display = "none";
        });
    }

    function show(type) {
        hideAll();
        const btn = buttons[type];
        if (btn) btn.style.display = "block";
    }

    function getVariantType(variant) {
        const vType = normalize(variant?.selling_options);

        if (vType) return vType;

        return globalType;
    }

    function applyInitialType() {
        const variant = data.variants[0];
        const type = getVariantType(variant);
        show(type);
    }

    applyInitialType();

    document.addEventListener("change", () => {
        const selectedValues = Array.from(
            document.querySelectorAll('variant-picker input[type="radio"]:checked')
        ).map(el => el.value.toLowerCase());

        const variant = data.variants.find(v =>
            v.options.map(o => o.toLowerCase()).join("|") === selectedValues.join("|")
        );

        if (!variant) return;

        const type = getVariantType(variant);
        show(type);
    });
});
